import { render, staticRenderFns } from "./ReceivedSamplesIndex.vue?vue&type=template&id=06e7f24d&"
import script from "./ReceivedSamplesIndex.vue?vue&type=script&lang=js&"
export * from "./ReceivedSamplesIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedSamplesIndex.vue?vue&type=style&index=0&id=06e7f24d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports